export const methods = {
  async reload() {
    this.loading = true

    this.ballotID = this.$route.params.id

    console.debug('ballotID=' + this.ballotID)

    this.loading = false
  },

  returnToParent() {
    this.$router.push({
      name: 'evoting'
    })
  }
}
